"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _state = require("./state");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(postal) {
  var queue = [];
  postal.addWireTap(function (data, envelope) {
    if (_state.state._config.queueingEnabled) {
      queue.push((0, _cloneDeep.default)(envelope));
    }
  });

  postal.iterateOverQueue = function () {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    queue.forEach(callback);
  };
};

exports.default = _default;